module.exports = "\n.my-login &:before {\n\tcontent: \"assets/login.png\"\n}"